<!-- eslint-disable vue/no-mutating-props -->
<template>
  <el-dialog
    v-model="show"
    width="600"
    :fullscreen="$vuetify.display.width <= 600 ? true : false"
    class="public-style"
    destroy-on-close
    align-center
    @close="close"
  >
    <el-form
      ref="ruleFormRef"
      :rules="rules"
      :model="baseline_data"
      :style="[$vuetify.display.width < 600 ? 'height: 550;' : '']"
      :label-position="`top`"
    >
      <el-space fill style="width: 100%">
        <el-alert type="info" class="alert-style" show-icon :closable="false">
          <p class="ma-0 text-white">Site Baseline Param :</p>
        </el-alert>
        <el-row :gutter="20">
          <el-col :span="$vuetify.display.width >= 500 ? 12 : 24">
            <el-form-item
              class="label-style"
              prop="monitoring_period_id"
              label="Monitoring Period: "
            >
              <!-- <el-input v-model="baseline_data.charger_type" /> -->
              <el-select
                v-model="baseline_data.monitoring_period_id"
                placeholder="Select"
                class="w-100"
              >
                <el-option
                  v-for="item in monitoringPeriods"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                  <span style="float: left">{{ item.name }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="$vuetify.display.width >= 500 ? 12 : 24">
            <el-form-item class="label-style" prop="country" label="Country: ">
              <el-input v-model="baseline_data.country" />
            </el-form-item>
          </el-col>
          <el-col :span="$vuetify.display.width >= 500 ? 12 : 24">
            <el-form-item
              class="label-style"
              prop="charger_type"
              label="Charger Type: "
            >
              <!-- <el-input v-model="baseline_data.charger_type" /> -->
              <el-select
                v-model="baseline_data.charger_type"
                placeholder="Select"
                class="w-100"
              >
                <el-option
                  v-for="item in chargerTypes"
                  :key="item.id"
                  :label="item.title"
                  :value="item.title"
                >
                  <span style="float: left">{{ item.title }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="$vuetify.display.width >= 500 ? 8 : 24">
            <el-form-item
              class="label-style"
              prop="dispatch_int"
              label="Dispatch Int: "
            >
              <el-input v-model="baseline_data.dispatch_int" />
            </el-form-item>
          </el-col>
          <el-col :span="$vuetify.display.width >= 500 ? 8 : 24">
            <el-form-item
              class="label-style"
              prop="fuel_emission_intensity"
              label="Fuel Emission Intensity: "
            >
              <el-input v-model="baseline_data.fuel_emission_intensity" />
            </el-form-item>
          </el-col>
          <el-col :span="$vuetify.display.width >= 500 ? 8 : 24">
            <el-form-item
              class="label-style"
              prop="charger_efficiency"
              label="Charger Efficiency: "
            >
              <el-input v-model="baseline_data.charger_efficiency" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="$vuetify.display.width >= 500 ? 6 : 24">
            <el-form-item class="label-style" prop="afec" label="Afec: ">
              <el-input v-model="baseline_data.afec" />
            </el-form-item>
          </el-col>
          <el-col :span="$vuetify.display.width >= 500 ? 6 : 24">
            <el-form-item class="label-style" prop="mpg" label="Mpg: ">
              <el-input v-model="baseline_data.mpg" />
            </el-form-item>
          </el-col>
          <el-col :span="$vuetify.display.width >= 500 ? 12 : 24">
            <el-form-item
              class="label-style"
              prop="tech_improvement_rate"
              label="Improvement Rate: "
            >
              <el-input v-model="baseline_data.tech_improvement_rate"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="$vuetify.display.width >= 500 ? 12 : 24">
            <el-form-item
              class="label-style"
              prop="fuel_energy_density_MJ_gal"
              label="Fuel Energy Density MJ Gal: "
            >
              <el-input v-model="baseline_data.fuel_energy_density_MJ_gal" />
            </el-form-item>
          </el-col>
          <el-col :span="$vuetify.display.width >= 500 ? 12 : 24">
            <el-form-item
              class="label-style"
              prop="fuel_energy_density_MJ_kWh"
              label="Fuel Energy Density MJ kWh: "
            >
              <el-input v-model="baseline_data.fuel_energy_density_MJ_kWh" value="3.6" readonly />
            </el-form-item>
          </el-col>
        </el-row>
      
        <el-row :gutter="20">
          <el-col :span="$vuetify.display.width >= 500 ? 12 : 24">
            <el-form-item
              class="label-style"
              prop="charging_site_id"
              label="Customer: "
            >
              <!-- <el-input v-model="user_data.customer_id" /> -->
              <el-select
                v-model="selectedCustomer_id"
                @change="handleCustomerSelect"
                placeholder="Select"
                filterable
                class="w-100"
                :disabled="this.action != 'new'"
                :loading="customersLoading"
              >
              <el-option
                  v-for="item in customers"
                  :key="item.id"
                  :label="item.full_name"
                  :value="item.id"
                >
                  <span style="float: left">{{ item.full_name }}</span>
                  <!-- <span style="text-align: center">{{ item.country }}</span> -->
                  <span
                    style="
                      float: right;
                      color: var(--el-text-color-secondary);
                      font-size: 13px;
                    "
                  >
                    {{ item.phone }}
                  </span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="$vuetify.display.width >= 500 ? 12 : 24">
            <el-form-item
              class="label-style"
              prop="charging_site_id"
              label="Charging Site: "
            >
              <!-- <el-input v-model="user_data.customer_id" /> -->
              <el-select
                v-model="baseline_data.charging_site_id"
                placeholder="Select"
                filterable
                class="w-100"
                :disabled="this.action != 'new'"
                :loading="loading"
              >
                <el-option
                  v-for="item in charging_sites"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                >
                  <span style="float: left">{{ item.title }}</span>
                  <span
                    style="
                      float: right;
                      color: var(--el-text-color-secondary);
                      font-size: 13px;
                    "
                  >
                    {{ item.city }}
                  </span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-space>
    </el-form>
    <!-- </el-row> -->
    <template #footer>
      <span class="dialog-footer">
        <el-button
          size="medium"
          class="me-primary-light"
          @click.stop="pasteData"
          :disabled="copiedData == null"
          color="#234B49"
        >
          <i class="fa fa-paste me-2 me-primary-light"></i><span class="moderat-btn-apply-light">Paste</span>
        </el-button>
        <el-button
          size="medium"
          class="me-primary-light"
          @click.stop="confirm"
          color="#234B49"
        >
          <i class="fa fa-check me-2 me-primary-light"></i><span class="moderat-btn-apply-light">Confirm</span>
        </el-button>
        <el-button
          size="medium"
          class="me-primary"
          @click.stop="close"
          color="#ddf0ac"
        >
          <i class="fa fa-times me-2 me-primary"></i><span class="moderat-btn-apply">Cancel</span>
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
// import "animate.css";
import UserService from "../../services/user.service";
import { ElMessageBox } from "element-plus";
// import moment from "moment";
export default {
  props: {
    open_modal: {
      type: Boolean,
      default: false,
    },
    data_modal: {
      type: Object,
      // eslint-disable-next-line no-unused-vars
      default(rawProps) {
        return rawProps;
      },
    },
    params_modal: {
      type: Array,
      default() {
        return [];
      },
    },
    action: {
      type: String,
      default: "new",
    },
    copiedDataProp: {
      type: Object,
      default() {
        return null;
      },
    },
    monitoringPeriodsProp: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      show: this.open_modal,
      customers: [],
      paramsIdList: [],
      selectedCustomer_id: null,
      rules: {
        monitoring_period_id: {
          required: true,
          message: "Please select a monitoring period.",
          trigger: "blur",
        },
        country: {
          required: true,
          message: "Please enter country.",
          trigger: "blur",
        },
        dispatch_int: [
          {
            required: true,
            message: "Please enter dispatch_int.",
            trigger: "blur",
          },
          {
            type: "number",
            trigger: "blur",
            asyncValidator: (rule, value) => {
              return new Promise((resolve, reject) => {
                if (!this.isNumeric(value)) {
                  reject("dispatch_int must be digit");
                } else {
                  resolve();
                }
              });
            },
          },
        ],
        charger_type: {
          type: "enum",
          enum: ["AC", "DC"],
          message: "charger_type must be Ac or DC",
          trigger: "blur",
        },
        fuel_emission_intensity: [
          {
            required: true,
            message: "Please enter fuel_emission_intensity.",
            trigger: "blur",
          },
          {
            type: "number",
            trigger: "blur",
            asyncValidator: (rule, value) => {
              return new Promise((resolve, reject) => {
                if (!this.isNumeric(value)) {
                  reject("fuel_emission_intensity must be digit");
                } else {
                  resolve();
                }
              });
            },
          },
        ],
        afec: [
          {
            required: true,
            message: "Please enter afec.",
            trigger: "blur",
          },
          {
            type: "number",
            trigger: "blur",
            asyncValidator: (rule, value) => {
              return new Promise((resolve, reject) => {
                if (!this.isNumeric(value)) {
                  reject("afec must be digit");
                } else {
                  resolve();
                }
              });
            },
          },
        ],
        mpg: [
          {
            required: true,
            message: "Please enter mpg.",
            trigger: "blur",
          },
          {
            type: "number",
            trigger: "blur",
            asyncValidator: (rule, value) => {
              return new Promise((resolve, reject) => {
                if (!this.isNumeric(value)) {
                  reject("mpg must be digit");
                } else {
                  resolve();
                }
              });
            },
          },
        ],
        charger_efficiency: [
          {
            required: true,
            message: "Please enter charger_efficiency.",
            trigger: "blur",
          },
          {
            type: "number",
            trigger: "blur",
            asyncValidator: (rule, value) => {
              return new Promise((resolve, reject) => {
                if (!this.isNumeric(value)) {
                  reject("charger_efficiency must be digit");
                } else {
                  resolve();
                }
              });
            },
          },
        ],
        tech_improvement_rate: [
          {
            required: true,
            message: "Please enter improvement_rate.",
            trigger: "blur",
          },
          {
            type: "number",
            trigger: "blur",
            asyncValidator: (rule, value) => {
              return new Promise((resolve, reject) => {
                if (!this.isNumeric(value)) {
                  reject("improvement_rate must be digit");
                } else {
                  resolve();
                }
              });
            },
          },
        ],
        fuel_energy_density_MJ_gal: [
          {
            required: true,
            message: "Please enter fuel_energy_density_MJ_gal.",
            trigger: "blur",
          },
          {
            type: "number",
            trigger: "blur",
            asyncValidator: (rule, value) => {
              return new Promise((resolve, reject) => {
                if (!this.isNumeric(value)) {
                  reject("fuel_energy_density_MJ_gal must be digit");
                } else {
                  resolve();
                }
              });
            },
          },
        ],
        // fuel_energy_density_MJ_kWh: [
        //   {
        //     required: true,
        //     message: "Default Fuel Energy Density MJ kWh is 3.6.",
        //     trigger: "blur",
        //   },
        //   {
        //     type: "number",
        //     trigger: "blur",
        //     asyncValidator: (rule, value) => {
        //       return new Promise((resolve, reject) => {
        //         if (!this.isNumeric(value)) {
        //           reject("fuel_energy_density_MJ_kWh must be digit");
        //         } else {
        //           resolve();
        //         }
        //       });
        //     },
        //   },
        // ],
      },
      baseline_data: {
        id: 0,
        country: "",
        dispatch_int: 0,
        charger_type: "AC",
        fuel_emission_intensity: 0.0,
        afec: 0.0,
        mpg: 0.0,
        charger_efficiency: 0.0,
        tech_improvement_rate: 0.0,
        fuel_energy_density_MJ_gal: 0.0,
        fuel_energy_density_MJ_kWh: 3.6,
      },
      chargerTypes: [
        { id: 1, title: "AC" },
        { id: 2, title: "DC" },
      ],
      primarySites: [],
      charging_sites: [],
      loading: false,
      customersLoading: false,
      monitoringPeriods: [],
      copiedData: null,
    };
  },
  mounted() {
  },
  watch: {
    monitoringPeriodsProp: {
      handler: function (newValue) {
        this.monitoringPeriods = newValue;
      },
      deep: true,
    },
    copiedDataProp: {
      handler: function (newValue) {
        this.copiedData = newValue;
      },
      deep: true,
    },
    // eslint-disable-next-line no-unused-vars
    open_modal: function (newVal, oldVal) {
      // this.customers = [];
      this.baseline_data = this.normalizeBaselineData(this.baseline_data);
      this.baseline_data.charging_site_id = null;
      this.selectedCustomer_id = null;
      this.show = newVal;
      if (newVal == true) {
        this.baseline_data = this.normalizeBaselineData(
          typeof this.data_modal === "string"
            ? JSON.parse(this.data_modal)
            : this.data_modal
        );
        // console.log(this.baseline_data);
        setTimeout(() => {
          this.fetchCustomerData();
        }, 1000);
      }
    },

    // received site baseline params list from parent component
    params_modal: function (newVal) {
      if (newVal != null) {
        Array.from(newVal).forEach((item) => {
          this.paramsIdList.push(item.id);
        });
      }
    },
    // checking if the selected charging site already exists in the site baselin params table
    "baseline_data.charging_site_id": function (newVal) {
      if (newVal != null) {
        if (newVal in this.paramsIdList) {
          this.baseline_data.charging_site_id = null;
          ElMessageBox.alert(
            "This Charging site already exists, please edit it from site baseline params table.",
            "Error",
            {
              type: "error",
              showClose: false,
              showCancelButton: false,
              showConfirmButton: true,
              confirmButtonText: "OK",
            }
          ).then(() => {
            this.baseline_data.charging_site_id = null;
          }).catch((error) => {
            console.log(error);
          }).finally(() => {
            this.baseline_data.charging_site_id = null;
            return;
          });
        }
      }
    },
  },
  methods: {
    getDefaultBaselineData() {
      return {
        id: 0,
        country: "",
        dispatch_int: 0,
        charger_type: "AC",
        fuel_emission_intensity: 0.0,
        afec: 0.0,
        mpg: 0.0,
        charger_efficiency: 0.0,
        tech_improvement_rate: 0.99,
        fuel_energy_density_MJ_gal: 0.0,
        fuel_energy_density_MJ_kWh: 3.6,
      };
    },

    normalizeBaselineData(data) {
      return {
        ...this.getDefaultBaselineData(),
        ...(data || {}),
      };
    },


    // fetching customers for select customer dropdown
    async fetchCustomerData() {
      this.customersLoading = true;
      await UserService.getCustomers(null)
        .then(
          (response) => {
            this.customers = response.data.customers;
          },
          (error) => {
            this.customersLoading = false;
            console.log(error);
            if (error.response.status == 401) {
              this.$router.push({
                path: "/",
              });
            }
          }
        )
        .catch((error) => {
          this.customersLoading = false;
          console.log(error);
          if (error.response.status == 401) {
            this.$router.push({
              path: "/",
            });
          }
        })
        .finally(() => (this.customersLoading = false));
    },

    handleCustomerSelect(item) {
      // console.log(item);
      this.selectedCustomer_id = item;
      this.baseline_data.charging_site_id = null;
      this.loading = true;
      this.fetchCustomerChargingSite();
    },

    // fetching charging sites for selected customer
    // show charging sites in dropdown without pagnation
    async fetchCustomerChargingSite() {
      let body = {
        customer_id: this.selectedCustomer_id,
      };
      await UserService.getChargingSites(body, "", 1, 0)
        .then(
          (response) => {
                this.charging_sites = response.data.charging_sites;

          },
          (error) => {
            this.loading = false;
            console.log(error);
            if (error.response.status == 401) {
              this.$router.push({
                path: "/",
              });
            }
          }
        )
        .catch((error) => {
          this.loading = false;
          console.log(error);
          if (error.response.status == 401) {
            this.$router.push({
              path: "/",
            });
          }
        })
        .finally(() => (this.loading = false));
    },
    isNewUser() {
      if (this.baseline_data.id == 0) return true;
      else return false;
    },
    close() {
      this.show = false;
      this.$emit("close_modal", false);
    },
    
    pasteData() {
      this.baseline_data.monitoring_period_id = null;
      this.baseline_data.country = this.copiedData.country;
      this.baseline_data.dispatch_int = this.copiedData.dispatch_int;
      this.baseline_data.charger_type = this.copiedData.charger_type;
      this.baseline_data.fuel_emission_intensity = this.copiedData.fuel_emission_intensity;
      this.baseline_data.afec = this.copiedData.afec;
      this.baseline_data.mpg = this.copiedData.mpg;
      this.baseline_data.charger_efficiency = this.copiedData.charger_efficiency;
      this.baseline_data.tech_improvement_rate = this.copiedData.tech_improvement_rate;
      this.baseline_data.fuel_energy_density_MJ_gal = this.copiedData.fuel_energy_density_MJ_gal;
      this.baseline_data.fuel_energy_density_MJ_kWh = this.copiedData.fuel_energy_density_MJ_kWh;
    },

    async confirm() {
      await this.$refs["ruleFormRef"].validate((valid, fields) => {
        if (valid) {
          console.log(this.baseline_data);
          UserService.SetSiteBaselineParam(this.baseline_data)
            .then(
              (response) => {
                this.$emit("confirm_modal", response.data.site_baseline_param);
                this.$emit("refreshBaselineData");
              },
              (error) => {
                // this.loading = false;
                console.log(error);
                if (error.response.status == 401) {
                  this.$router.push({
                    path: "/",
                  });
                }
              }
            )
            .catch((error) => {
              // this.loading = false;
              console.log(error);
              if (error.response.status == 401) {
                this.$router.push({
                  path: "/",
                });
              }
            })
            .finally(() => (this.loading = false));
        } else {
          console.log("error submit!", fields);
        }
      });
    },
    isNumeric: function (n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    },
  },
};
</script>

<style>
.el-dialog__body {
  padding: 30px 10px;
}
.el-input__inner {
  padding: 0 10px !important;
}

::-webkit-scrollbar {
  width: 8px;
}
/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.el-form-item__label {
  margin-bottom: 0 !important;
}
.el-form-item__content > .el-checkbox {
  margin-top: 16px;
  margin-bottom: 0;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
